import { Box, Grid, SvgIcon, Typography } from '@mui/material';
import logo from '@assets/svgs/logo.svg';
import SpecialtyLogo from '@assets/svgs/lsic-logo.svg';
import { Sync } from '@assets/svgs';

interface LoadingInterface {
  children?: string;
}

export const Loading = () => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'center',
      width: '100%',
      height: '24px',
    }}
    data-testid='loading-spinner'
  >
    <SvgIcon
      inheritViewBox
      sx={(theme) => ({
        animation: theme.animations.spin,
        color: ({ palette }) => palette.text.subdued,
        ...theme.icons.md,
      })}
    >
      {/* // undefined makes this spin correctly as the icon is not square */}
      <Sync title='loading-spinner' height={undefined} width={undefined} />
    </SvgIcon>
  </Box>
);
export default Loading;

export const FullscreenLoading = ({ children = 'Loading...' }: LoadingInterface) => {
  const storedLogo = localStorage.getItem('logo') ?? '';
  const showSpecialtyLogo = storedLogo === 'lsic-logo';

  return (
    <Grid
      container
      sx={{
        justifyContent: 'center',
        alignItems: 'center',
        background: (theme) => theme.palette.background.gradient,
        minHeight: '100vh',
        height: '100%',
      }}
    >
      <Grid
        size={{
          xs: 12,
          sm: 11,
          md: 10,
          lg: 8,
          xl: 6,
        }}
      >
        <Grid
          container
          sx={{
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Grid>
            <img
              src={showSpecialtyLogo ? SpecialtyLogo : logo}
              alt={showSpecialtyLogo ? 'lsci-logo' : 'logo'}
              width='136px'
              height='136px'
            />
          </Grid>
          <Grid
            size={{ xs: 11 }}
            sx={{
              paddingTop: '32px',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
              }}
            >
              <Typography variant='h3' color='common.white'>
                {children}
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export const LoadingOverlay = () => (
  <Box sx={{ height: '88px', display: 'flex', justifyContent: 'center', alignItems: 'center', alignContent: 'center' }}>
    <Loading />
  </Box>
);
